(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["page-content"] && !Shopify.designMode) return;
  try {
    function initLavirenaSizeGuides(root = document) {
    root.querySelectorAll('[data-lav-size-guide]').forEach((guide) => {
      if (guide.dataset.lavSizeGuideReady === 'true') return;
      guide.dataset.lavSizeGuideReady = 'true';
      const buttons = guide.querySelectorAll('[data-size-unit]');
      const cells = guide.querySelectorAll('[data-mm]');
      const labels = guide.querySelectorAll('[data-size-unit-label]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const unit = button.dataset.sizeUnit;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          labels.forEach((label) => { label.textContent = unit === 'mm' ? '(mm)' : '(in)'; });
          cells.forEach((cell) => {
            const mm = Number(cell.dataset.mm);
            cell.textContent = unit === 'mm' ? cell.dataset.mm : (mm / 25.4).toFixed(2);
          });
        });
      });
    });
  }

  initLavirenaSizeGuides();
  document.addEventListener('shopify:section:load', (event) => { initLavirenaSizeGuides(event.target); });
  } catch(e) { console.error(e); }
})();

})();
